import React, { forwardRef } from 'react';
import styled from 'styled-components';

import { Crop } from './types';

export type Props = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  crop: Crop;
  imageUrl: string;
};

const Root = styled.div<{ aspect: number }>`
  overflow: hidden;
  position: relative;
  &::after {
    content: '';
    display: block;
    padding-block-end: ${({ aspect }) => 100 / aspect}%;
    width: 100%;
  }
`;

const Image = styled.img`
  height: 100%;
  left: 0;
  object-fit: cover;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 100%;
`;

const CropPreview = forwardRef<HTMLDivElement, Props>(({ className, crop, imageUrl, ...rest }: Props, ref) => {
  return (
    <Root {...rest} aspect={crop.aspect} className={className} ref={ref}>
      <Image
        src={imageUrl}
        style={{
          objectPosition: `${100 * crop.position.x}% ${100 * crop.position.y}%`,
          transform: `scale(${crop.zoom})`,
          transformOrigin: `${100 * crop.position.x}% ${100 * crop.position.y}%`,
        }}
      />
    </Root>
  );
});

export default CropPreview;
